// This file was automatically generated from appchart.dialog.ordermed.selectPharmacy.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.selectPharmacy');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.selectPharmacy.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><form class="ebs-form-horizontal"><div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium el8LgText ebs-control-label ebs-col-sm-2 padl0 mt2">Pharmacy:</label><div class="el8FieldMediumLabelPadding el8TextareaWrap ebs-col-sm-10"><input name="pharmacy" class="fieldBigText w100 ebs-form-control" maxlength=120 /></div></div><div class="el8FieldMediumLabelPadding el8AppText pharmacy-address-div ebs-col-sm-10 ebs-col-sm-offset-2 padb10"></div><div class="el8AppText spacer ebs-help-block">Note: You must select a pharmacy in order to ePrescribe.  Otherwise, you must print the prescription instead.</div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.selectPharmacy.pharmacyAddress = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="padb5">', soy.$$escapeHtml(opt_data.addressLine), '<br/>', soy.$$escapeHtml(opt_data.cityStateZip), '<br/>T: ', soy.$$escapeHtml(opt_data.phone), ', F: ', soy.$$escapeHtml(opt_data.fax), '</div>');
  if (opt_data.specialtyTypes) {
    var specialtyTypeList1997 = opt_data.specialtyTypes;
    var specialtyTypeListLen1997 = specialtyTypeList1997.length;
    for (var specialtyTypeIndex1997 = 0; specialtyTypeIndex1997 < specialtyTypeListLen1997; specialtyTypeIndex1997++) {
      var specialtyTypeData1997 = specialtyTypeList1997[specialtyTypeIndex1997];
      output.append('<span class="el8TagItem">', soy.$$escapeHtml(specialtyTypeData1997), '</span> ');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.selectPharmacy.mindreaderContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog"><div class="mr-dropdown-content el8MRContainer"><div class="mr-results-info el8MRInformText"></div><div class="mr-matches el8MRSection"></div></div></div>');
  if (!opt_sb) return output.toString();
};
